import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
} from "@/components/ui";
import { RequiresLiveVisitRejectionContent } from "@/features/Charting/components/VisitClosure/RequiresLiveVisitStep/RequiresLiveVisitRejectionContent";
import { useState } from "react";
import { useCancelReasonCodes } from "./network/useCancelReasonCodes";

interface RequiresLiveVisitRejectionModalProps {
  open: boolean;
  onOpenChange(open: boolean): void;
  onSubmit(args: {
    cancelReasonCode: string;
    cancelReasonText?: string;
  }): void | Promise<void>;
  isSending?: boolean;
}

export function RequiresLiveVisitRejectionModal({
  open,
  onOpenChange,
  onSubmit,
  isSending = false,
}: RequiresLiveVisitRejectionModalProps) {
  const [cancelReasonCode, setCancelReasonCode] = useState<string>("");
  const [cancelReasonText, setCancelReasonText] = useState("");
  const { data: reasonCodes } = useCancelReasonCodes();

  const trimmedText = cancelReasonText.trim();

  const handleSubmit = async () => {
    if (!cancelReasonCode) return;
    await onSubmit({
      cancelReasonCode,
      cancelReasonText: trimmedText || undefined,
    });
    setCancelReasonCode("");
    setCancelReasonText("");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogPortal>
        <DialogOverlay />
        <DialogContent className="w-full max-w-md">
          <DialogHeader>
            <DialogTitle>Async Cancellation Reason</DialogTitle>
            <DialogDescription className="hidden">
              async cancellation reason modal
            </DialogDescription>
          </DialogHeader>
          <RequiresLiveVisitRejectionContent
            reasonCodes={reasonCodes?.cancelReasonCodes}
            cancelReasonCode={cancelReasonCode}
            onCancelReasonCodeChange={setCancelReasonCode}
            cancelReasonText={cancelReasonText}
            onCancelReasonTextChange={setCancelReasonText}
            onSubmit={handleSubmit}
            isSending={isSending}
          />
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
